import React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import { Locale } from 'i18n';
import Head from 'src/components/Head';
import Layout from 'src/components/Layout';
import Docs from 'src/components/Docs/Docs';
import { DocId, DocData } from 'src/docs/types';
import { getDocDataById } from 'src/docs/utils';
import { getAllLocaleNDocIdPaths } from 'src/utils/getPaths';

interface Props {
  id: DocId;
  docData: DocData;
}

export default function Doc({ id, docData }: Props): React.ReactElement {
  return (
    <Layout doc id={id}>
      <Head title={docData.meta.title} description={docData.meta.description} />
      <Docs docData={docData} />
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  const docData = await getDocDataById(params?.id as DocId, locale as Locale);
  return {
    props: {
      id: params?.id,
      locale,
      docData,
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getAllLocaleNDocIdPaths();
  return {
    paths,
    fallback: false,
  };
};
